import React, { useContext } from "react";

import {
    Context,
    ServerCmsContextProcessorsNavigationItem as NavigationItem,
} from "@reactivated";

import { FavoritesContext } from "../../favorites";
import { PageNav } from "./PageNav";

/**
 * Thin wrapper to separate context from PageNav, which originally was created
 * to work around a problem that ReactivatedContext solved, but FavoritesContext
 * is still in here and we're gonna move away from this nav anyways so I didn't
 * feel the need to remove this
 */
export const PageNavWrapper = (props: { nav: NavigationItem[] }) => {
    const context = React.useContext(Context);

    const favs = useContext(FavoritesContext);

    return (
        <PageNav
            nav={props.nav}
            logoUrl={context.core_assets.logo}
            favs={favs}
        />
    );
};
